<template>
  <div
    v-if="isShow"
    class="form-group">
    <div class="form-label">
      <label class="control-label">コンテスト応募</label>
    </div>
    <div class="form-item">
      <div class="checkbox">
        <label for="enter_campaign">
          <input
            id="enter_campaign"
            v-model="item.is_entry"
            type="checkbox"
            name="enter_campaign"
            :true-value="1"
            :false-value="0">
          <div class="option-input"></div>
          narasuボカロ楽曲コンテスト2022に応募する
        </label>
      </div>
      <div class="form-item-text">
        narasuボカロ楽曲コンテスト2022の
        <router-link
          :to="{ name : 'narasu-vocacolle-campaign-202210' }"
          class="c-text-link"
          target="_blank">
          詳細はこちら
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VocaloidContest',
  props: {
    bus: { type: Object, default: () => {}, required: false },
    track: { type: Object, default: () => {}, required: true },
    productId: { type: Number, default: 0, required: true },
  },
  data() {
    return {
      item: {
        is_entry: 1,
      },
      campaigns: [],
      enter_campaign: 0,
      isShow: false,
    }
  },
  watch: {
    'track.main_artists': {
      handler() {
        this.isShow = this.isVocaloid()
      },
      deep: true,
    },
    'track.featuring_artists': {
      handler() {
        this.isShow = this.isVocaloid()
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchCampaigns()
    if (this.bus) {
      this.bus.$on('submit', this.submit)
    }
  },
  methods: {
    async fetchCampaigns() {
      const { data } = await window.axios.get('/api/client/campaigns', {
        params: {
          keys: ['vocaloid_contest202210'], // ボーカロイドコンテストのキャンペーンを取り出す
        },
      })
      this.campaigns = data
      this.isShow = this.isVocaloid()
      // コンテストのキャンペーンが登録されているかチェック
      const contest = this.campaigns.find((campaign) => campaign.key === 'vocaloid_contest202210') ?? false
      if (contest && contest.entries) {
        // コンテストのエントリーデータがあればセット
        // 無い場合はデフォルトで参加をセット
        const entry = contest.entries.find((ent) => ent.product_id === this.productId
          && ent.product_disc_track_id === this.track.id) ?? { is_entry: 1 }
        this.item = entry
      }
    },
    isVocaloid() {
      // コンテストのキャンペーンデータが存在するか
      const contest = this.campaigns.some((campaign) => campaign.key === 'vocaloid_contest202210') ?? false

      // メインアーティストにボーカロイドが含まれているか
      // const main = this.track.main_artists.some(artist => artist.type === 3)
      // Featuringアーティストにボーカロイドが含まれているか
      // const featuring = this.track.featuring_artists.some(artist => artist.type === 3)
      // エントリー済みでアーティストにボーカロイドが含まれていばtrue
      return contest && this.isBtoC
    },
    async submit() {
      const contest = this.campaigns.find((campaign) => campaign.key === 'vocaloid_contest202210')
      if (contest === undefined) {
        return
      }

      if (this.item.id) {
        // コンテスト対象で無くなった場合は参加を取消
        this.item.is_entry = this.isShow === false ? 0 : this.item.is_entry
        const { data } = await window.axios.put(`/api/client/campaigns/${contest.id}/entry/${this.item.id}`, this.item)
        this.item = data
      } else if (this.isShow === true) {
        // 新規登録場合はエントリデータを登録
        this.item.product_disc_track_id = this.track.id
        this.item.product_id = this.productId
        const { data } = await window.axios.post(`/api/client/campaigns/${contest.id}/entry`, this.item)
        this.item = data
      }
    },
  },
}
</script>
<style scoped>
.form-group{
  border-top: 1px solid #dadada;
}
</style>
